module.exports = __webpack_public_path__ + "static/media/FracShackLogoStackedNoTm.bdf9bb17.svg";